import React, { FC } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Text,
  ChakraProps,
  InputLeftAddon,
  InputGroup,
  InputRightAddon,
  IconProps,
  Icon,
} from "@chakra-ui/react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";

interface InputFieldProps extends DefaultFieldProps {
  leftAddOn?: IconProps | string;
  leftIconClick?: () => void;
  rightAddOn?: IconProps | string;
  rightIconClick?: () => void;
  rightIconStyle?: ChakraProps;
  leftIconStyle?: ChakraProps;
  isDisabled?: boolean;
  placeholder?: any;
}

const InputField: FC<FieldRenderProps<InputFieldProps & any>> = (props) => {
  const {
    meta,
    input,
    label,
    inputProps,
    inputGroupProps,
    labelProps,
    formGroupProps,
    errorProps,
    leftAddOn,
    leftIconClick,
    rightAddOn,
    rightIconClick,
    leftIconStyle,
    rightIconStyle,
    isDisabled,
    placeholder,
  } = props;

  return (
    <FormControl {...formGroupProps} position="relative">
      <FormLabel {...labelProps}>{label}</FormLabel>

      <InputGroup {...inputGroupProps}>
        {leftAddOn && (
          <InputLeftAddon
            {...leftIconStyle}
            onClick={leftIconClick}
            children={
              typeof leftAddOn !== "string" ? (
                <Icon as={leftAddOn} />
              ) : (
                leftAddOn
              )
            }
          />
        )}

        <Input
          {...input}
          {...inputProps}
          placeholder={placeholder}
          rounded="sm"
          focusBorderColor="green.500"
          disabled={isDisabled}
        />

        {rightAddOn && (
          <InputRightAddon
            {...rightIconStyle}
            onClick={rightIconClick}
            children={
              typeof rightAddOn !== "string" ? (
                <Icon as={rightAddOn} />
              ) : (
                rightAddOn
              )
            }
          />
        )}
      </InputGroup>

      {meta.error && meta.touched && (
        <Text
          {...errorProps}
          color="red.300"
          fontSize="sm"
          textAlign="end"
          mx="3"
          position="absolute"
          right={0}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default InputField;
